module.exports = __webpack_public_path__ + "img/login_dialog_pc.96bc36b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_dialog_pc.png
// module id = Fn75
// module chunks = 1 4